<template functional>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path id="Path_27969" data-name="Path 27969" d="M12.25,2.25a10,10,0,1,0,10,10,10,10,0,0,0-10-10ZM16.1,13.019H13.019V16.1a.769.769,0,1,1-1.538,0V13.019H8.4a.769.769,0,1,1,0-1.538h3.077V8.4a.769.769,0,1,1,1.538,0v3.077H16.1a.769.769,0,1,1,0,1.538Z" transform="translate(-2.25 -2.25)" fill="#56db6d"/>
  </svg>
</template>

<script>
export default {
  name: 'IconCirclePlus',

  props: {
    size: { type: [String, Number], default: '20px' },
  }
}
</script>